import {urlUtil} from './index'

export default {
  getUrl,
}

function getUrl (path, redirect=true) {
  // Fix email:address links
  if (path.indexOf('mailto:') == 0) return path

  if (!redirect) return urlUtil.path(path, true)
  else if (path.indexOf('/app/redirect/new?to=') === -1)
    return urlUtil.path('/app/redirect/new?to=' + encodeURIComponent(encodeURIComponent(path)))
  else return  urlUtil.path(path)
}

        

    
